export class List {
  constructor(classObj, list) {
    this.class = classObj
    this.list = list ? list.map(el => new  this.class(el)): []
  }

  add(item) {
    this.list.push(new this.class(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, new this.class(item))
  }

  remove(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }
}